import { db, firebase } from '@/plugins/firebase';
import * as DateTime from '@/utils/date';

export const PURCHASE_KIND = {
  "GIFT": "gift",
  "OPEN_LIVE": "openLive",
  "INDIVIDUAL_LIVE": "individualLive"
};

export const TYPE = {
  "PAID": "doron",
  "FREE": "freeDoron"
};

export async function getDoronDoc(userId) {
  const doronDocQuerySnapShot = await db.collection('dorons').doc(userId).get();
  return doronDocQuerySnapShot.data();
}

export async function updateDoronDoc(userId, payload) {
  let success = true; // Firebaseへの更新成功を示す制御フラグ
  const doronDocRef = await db.collection('dorons').doc(userId);
  await doronDocRef
    .set(
      {
        ...payload,
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      },
      { merge: true }
    )
    .catch(err => {
      console.error(err);
      success = false;
    });

  if (!success) return;

  const doronDocSnapShot = await doronDocRef.get();
  return doronDocSnapShot.data();
}

export async function addUnusedDoronDoc(userId, payload) {
  const doronDocRef = await db.collection('dorons').doc(userId);
  try {
    let created = DateTime.fromUnix(payload.created);
    let expireAt = DateTime.addToDate(1, 'year', created);

    await doronDocRef.update({
      unUsedDoron: firebase.firestore.FieldValue.arrayUnion({
        total: payload.amount,
        remain: payload.amount,
        expireAt: expireAt
      }),
      unUsedFreeDoron: firebase.firestore.FieldValue.arrayUnion({
        total: payload.freeAmount,
        remain: payload.freeAmount,
        expireAt: expireAt
      })
    });
    const doronDocSnapShot = await doronDocRef.get();
    return doronDocSnapShot.data();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function addUsedDoronDoc(userId, payload) {
  const doronDocRef = await db.collection('dorons').doc(userId);
  try {
    await doronDocRef.update({
      usedDoron: firebase.firestore.FieldValue.arrayUnion(
        ...payload.usedDoronArray
      ),
      usedFreeDoron: firebase.firestore.FieldValue.arrayUnion(
        ...payload.usedFreeDoronArray
      )
    });
    const doronDocSnapShot = await doronDocRef.get();
    return doronDocSnapShot.data();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function addPurchaseHistory(purchaseKind, userId, castId, liveId, type, amount) {
  const params = {
    purchaseKind: purchaseKind,
    userId: userId,
    castId: castId,
    liveId: liveId,
    type: type,
    amount: amount,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp()
  }

  await db.collection('purchaseHistory').add(params)
    .catch(err => {
      console.error(err);
    });
}

export async function getPurchaseHistoryByUserId(userId) {
  let resultList = [];
  const querySnapshot = await db
    .collection('purchaseHistory')
    .where('userId', '==', userId)
    .orderBy('updatedAt', 'desc')
    .get();

  if (querySnapshot.empty) {
    return resultList;
  } else {
    querySnapshot.forEach(doc => {
      resultList.push(doc.data());
    });
  }
  return resultList;
}

export async function getPurchaseHistoryByCastId(castId) {
  let resultList = [];
  const querySnapshot = await db
    .collection('purchaseHistory')
    .where('castId', '==', castId)
    .orderBy('updatedAt', 'desc')
    .get();

  if (querySnapshot.empty) {
    return resultList;
  } else {
    querySnapshot.forEach(doc => {
      resultList.push(doc.data());
    });
  }
  return resultList;
}

export async function getPurchaseHistoryByLiveId(liveId) {
  let resultList = [];
  const querySnapshot = await db
    .collection('purchaseHistory')
    .where('liveId', '==', liveId)
    .get();

  if (querySnapshot.empty) {
    return resultList;
  } else {
    querySnapshot.forEach(doc => {
      resultList.push(doc.data());
    });
  }
  return resultList;
}
